import React from 'react';
import styled from 'styled-components';
import Header from '../../components/header';
import Helmet from 'react-helmet';

import SectionWrapper from '../../components/products/events/SectionWrapper';
import RegistrationAndTicketing from '../../components/products/events/RegistrationAndTicketing';
import ProductIntroduce from '../../components/products/events/ProductIntroduce';
import PaymentMethods from '../../components/products/events/PaymentMethods';
import TopBanner from '../../components/products/membership/topBanner';
import MembershipManagement from '../../components/products/membership/simplifyMembershipManagement';
import FunctionalityTilesList from '../../components/products/membership/FunctionalityTilesList';
import CheckList from '../../components/products/membership/CheckList';

import GrowYourMembershipImg from '../../images/products/membership/growyourmembership.png';
import GrowYourMembershipImg2x from '../../images/products/membership/growyourmembership@2x.png';
import GrowYourMembershipImg3x from '../../images/products/membership/growyourmembership@3x.png';
import SuitsAllOrganizationImg from '../../images/products/membership/SuitsAllOrganizationImg.svg';
import EventsLogoImg from '../../images/products/membership/events_logo.svg';
import EngagementLogoImg from '../../images/products/membership/engagement_icon.svg';
import MembershipLogoImg from '../../images/membership-icon.svg';

import JuvencardImg from '../../images/products/membership/juvencard.png';
import JuvencardImg2x from '../../images/products/membership/juvencard@2x.png';
import JuvencardImg3x from '../../images/products/membership/juvencard@3x.png';

import memberIcon from '../../images/products/membership/membercard-1x.png';
import memberIcon2x from '../../images/products/membership/membercard-2x.png';
import memberIcon3x from '../../images/products/membership/membercard-3x.png';

import { translate } from '../../../i18n';
import { colors, transition } from '../../utils/styles';
import GetStarted from '../../components/products/GetStarted';
import CustomizeCard from '../../components/products/membership/CustomizeCard';

const t = translate('pages/products/membership');

const { GATSBY_MANAGER_URL } = process.env;

const ProductDescription = styled.div`
  font-size: 12px;
  line-height: 1.6;
  width: 95%;
  margin: 10px auto 30px;
  text-align: center;

  @media (min-width: 901px) {
    font-size: 15px;
    margin: 20px auto 30px;
  }
`;

const SectionHeading = styled.h2`
  text-align: center;
  font-size: 25px;
  line-height: 1.2;
  font-weight: bold;
  margin: 0 auto;
  width: 100%;
  color: ${ ({ white }) => (white ? colors.white : colors.black) };
  padding-bottom: ${ props =>
    props.paddingBottom ? `${ props.paddingBottom }px` : '20px' };
  text-transform: none;

  @media (max-width: 900px) {
    font-size: ${ props =>
      props.fontSizeMob ? `${ props.fontSizeMob }px` : '25px' };
    width: 80%;
    padding-bottom: ${ props =>
      props.paddingBottomMob ? `${ props.paddingBottomMob }px` : '20px' };
  }
`;

const SectionInformation = styled.div`
  text-align: center;
  font-size: 15px;
  line-height: 1.6;
  margin: 0 auto;
  width: 100%;

  @media (max-width: 900px) {
    width: 71%;
    font-size: 12px;
  }
`;

const FlexWrapper = styled.div`
  display: flex;
  margin-top: 60px;
  align-items: center;

  @media (max-width: 900px) {
    margin-top: 30px;
  }
`;

const SectionImgWrapper = styled.div`
  width: 0%;

  @media (min-width: 901px) {
    width: 42.46%;
    height: 404px;
    padding-left: 5.5%;
  }
`;

const SectionImg = styled.img`
  display: none;

  @media (min-width: 901px) {
    display: block;
    // margin-top: 4%;
    width: 100%;
    height: 100%;
  }

  @media (min-width: 901px) and (max-width: 1030px) {
    margin-left: -2%;
  }
`;

const OverflowHidden = styled.div`
  overflow: hidden;
`;

const LayerOnTop = styled.div`
  position: relative;
  z-index: 2;
`;

const SideCircleWrapper = styled.div`
  position: relative;
`;
const SideCircleL = styled.div`
  display: inline-block;

  position: absolute;
  z-index: 1;
  top: -300px;
  left: -40px;

  background-image: linear-gradient(to right, #9de6ff, #64c9ff);

  height: 566px;
  width: 326px;
  border-bottom-right-radius: 566px;
  border-top-right-radius: 566px;

  @media (max-width: 900px) {
    top: -203px;
    height: 326px;
    width: 163px;
    border-bottom-right-radius: 326px;
    border-top-right-radius: 326px;
  }

  @media (max-width: 600px) {
    top: -203px;
    height: 253px;
    width: 126px;
    border-bottom-right-radius: 253px;
    border-top-right-radius: 253px;
  }
`;

const SideCircleR = styled.div`
  display: inline-block;

  position: absolute;
  z-index: 1;
  top: -400px;
  right: 0px;

  background-image: linear-gradient(to left, #9de6ff, #64c9ff);

  height: 566px;
  width: 326px;
  border-bottom-left-radius: 566px;
  border-top-left-radius: 566px;

  @media (max-width: 900px) {
    top: -163px;
    height: 326px;
    width: 163px;
    border-bottom-left-radius: 326px;
    border-top-left-radius: 326px;
    right: 0px;
  }

  @media (max-width: 600px) {
    top: -163px;
    height: 253px;
    width: 126px;
    border-bottom-left-radius: 253px;
    border-top-left-radius: 253px;
  }
`;

const TryItTodayBtn = styled.div`
  margin: 30px auto 0 auto;
  width: 174px;
  height: 42px;
  border-radius: 25px;
  background-color: white;
  color: #01a7ff;
  line-height: 2.8;
  font-size: 15px;
  font-weight: 700;
  text-align: center;

  &:after {
    content: 'Try it today';
  }

  &:hover {
    background-color: ${ colors.mainBlue };
    color: white;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.15);
  }

  ${ transition('all 0.3s ease') };
`;

const FunctionalityListInfo = [
  {
    title: 'Events',
    description:
      'Event management is really easy. Our ticketing system helps you throughout the event from checking in, in-event activities to post-event analytics.',
    link: '/products/events',
    img_src: EventsLogoImg,
    asCardLink: true
  },
  {
    title: 'Engagement',
    description:
      'Collaborate with ease, no more missing out on follow-ups. Build your community and turn every event goer into your members.',
    link: '/products/engagement',
    img_src: EngagementLogoImg,
    asCardLink: true
  }
];

const ChecklistInfo = [
  'Brands and commercial',
  'Sports clubs',
  'Arts and cultural',
  'Networking, alumni and educational',
  'Industry groups and chambers of commerce'
];

const Membership = props => (
  <div>
    <Helmet title={ t('Membership Management | Juven') }>
      <meta
        name='description'
        content={ t(
          'Looking for a better membership management system? Juven is a smart and powerful online membership software to help engage with your members easily. Get started now!'
        ) }
      />
    </Helmet>

    <Header
      desktopNotFixed
      mobileHidden={ false }
      navigationBarNotFixed
      showLanguage
    />

    <TopBanner
      headerIconSrcSet={ `${ memberIcon3x } 3x, ${ memberIcon2x } 2x, ${ memberIcon } 1x` }
      bannerImageSrcSet={ `${ JuvencardImg3x } 3x, ${ JuvencardImg2x } 2x, ${ JuvencardImg } 1x` }
      heading='Smart, automated and intuitive membership management'
      subHeading='Increase engagement, foster loyalty and grow revenue'
      source='membership'
    />

    <CustomizeCard source='membership' />

    <SideCircleWrapper>
      <SideCircleL />
    </SideCircleWrapper>

    <MembershipManagement />

    <OverflowHidden>
      <SectionWrapper
        paddingTop='105'
        paddingBottomMob='90'
        paddingTopMob='90'
        zindex='800'
      >
        <LayerOnTop>
          <ProductIntroduce
            title={ t('Flexible. Affordable. Scalable.') }
            fontSizeWeb='25'
            fontSizeMob='20'
          />
          <ProductDescription>
            { t(
              'No setup fee or monthly fees, you\'re only charged when you successfully receive a payment from a member'
            ) }
          </ProductDescription>
          <PaymentMethods
            image={ MembershipLogoImg }
            title={ t('Membership Manager') }
            pricing={{ percent: 5 }}
            source='membership'
          />
        </LayerOnTop>
      </SectionWrapper>

      <SideCircleWrapper>
        <SideCircleR />
      </SideCircleWrapper>

      <SectionWrapper backgroundColor paddingTopMob='90' paddingBottomMob='90'>
        <LayerOnTop>
          <SectionHeading
            fontSizeMob='20'
            paddingBottom='15'
            paddingBottomMob='30'
          >
            { t('Get found and stay connected') }
          </SectionHeading>
          <RegistrationAndTicketing
            description={ `${ t(
              'Attract and recruit new members on Juven. We\'re quickly becoming the go-to destination to find interesting events and membership offers.'
            ) }` }
            imgSrc={ GrowYourMembershipImg }
            descriptionLineHeight='1.6'
            wideImg
            descriptionInMid
            marginTopMob='0'
            noExtraMarginTop
            contentMarginTop='10'
            headingMarginBottom='10'
            descriptionFontSize='12'
            titleSpacing='20'
            srcSet={ `${ GrowYourMembershipImg3x } 3x, ${ GrowYourMembershipImg2x } 2x, ${ GrowYourMembershipImg } 1x` }
            title={ t('Grow your membership database on the Juven platform') }
          />
        </LayerOnTop>
      </SectionWrapper>

      <SectionWrapper paddingTop='120' paddingTopMob='90' paddingBottomMob='90'>
        <SectionHeading fontSizeMob='20'>
          { t('Juven suits all kinds of organizations') }
        </SectionHeading>
        <SectionInformation>
          { t(
            'From individuals to event organizers, small groups to member\'s only clubs, Juven help you drive loyalty and handle your needs.'
          ) }
        </SectionInformation>
        <FlexWrapper>
          <SectionImgWrapper>
            <SectionImg
              src={ SuitsAllOrganizationImg }
              alt='Suits all organizations'
            />
          </SectionImgWrapper>
          <CheckList
            list={ ChecklistInfo }
            buttonText='Try it today'
            url={ `${ GATSBY_MANAGER_URL }/signup` }
            source='membership'
          />
        </FlexWrapper>
      </SectionWrapper>
    </OverflowHidden>

    <GetStarted
      heading={ t('Create your membership plan now!') }
      buttonText={ t('Try it today') }
      url={ `${ GATSBY_MANAGER_URL }/signup` }
      source='membership'
    />
    <SectionWrapper backgroundColor paddingTop='120' paddingTopMob='90'>
      <SectionHeading fontSizeMob='20' paddingBottom='15' paddingBottomMob='30'>
        { t('Explore other features in Juven') }
      </SectionHeading>
      <FunctionalityTilesList
        marginTopMob='0'
        asCardLink
        descriptionFontSize='20'
        list={ FunctionalityListInfo }
      />
    </SectionWrapper>
  </div>
);

export default Membership;



// WEBPACK FOOTER //
// ./src/pages/products/membership.jsx